<div class="markers-container" [ngClass]="{'vertical-layout': verticalLayout}">
  @for (marker of visibleMarkers$ | async; track marker) {
    <div class="marker-container" [ngClass]="{'ai-style': aiStyle}">
      <marker
        [aiStyle]="aiStyle ? aiStyle : marker.is_ai_marker"
        [marker]="marker"
        [withCount]="withCount"
        [withName]="withName">
      </marker>
      @if (withCount) {
        <span>
          {{marker.count}}
        </span>
      }
    </div>
  }

  @if (showOverflow$ | async) {
    <div class="overflow-indicator" translate="common_plus-more" [translateParams]="{count: hiddenCount$ | async}"></div>
  }
</div>
